
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 25 25","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M6.873 18.294v-1.673L4.03 15.2 2.927 9.12l-2.92-.9s-.026 2.397 1.732 4.503l-1.5.454s1.798 4.864 6.634 5.117zM23.799 13.177l-1.501-.454c1.758-2.106 1.731-4.502 1.731-4.502l-2.919.899-1.104 6.08-2.842 1.42v1.674c4.835-.253 6.634-5.117 6.634-5.117zM15.129 1.998c1.35.32 2.526.808 3.472 1.296.758-1.583 2.13-3.25 2.13-3.25-2.887 0-4.637 1.058-5.602 1.954zM5.435 3.294a15.336 15.336 0 013.472-1.296C7.943 1.102 6.192.045 3.305.045c0 0 1.372 1.666 2.13 3.25zM5.42 6.744a4.603 4.603 0 002.742 1.428l.198.027a5.983 5.983 0 013.662 1.953A5.983 5.983 0 0115.684 8.2l.198-.027a4.603 4.603 0 002.741-1.428l1.061-1.146c-1.158-.827-4.017-2.559-7.662-2.559-3.646 0-6.504 1.732-7.663 2.56L5.42 6.743z","fill":"#E7E5EC"}}),_c('path',{attrs:{"d":"M15.757 19.37l-1.646 1.043-.753-1.19 2.4-1.52v-1.955l2.99-1.495 1.26-6.94-.354.382a6.014 6.014 0 01-3.583 1.867l-.198.027a4.58 4.58 0 00-3.258 2.101l-.595.946-.596-.946A4.58 4.58 0 008.166 9.59l-.198-.027a6.014 6.014 0 01-3.582-1.867l-.355-.383 1.261 6.941 2.99 1.495v1.955l2.4 1.52-.754 1.19-1.646-1.044v.957a3.738 3.738 0 107.475 0v-.957zm.418-8.19l.539 1.301-2.072.858-.539-1.3 2.072-.858zm-8.85 1.301l.54-1.3 2.071.858-.538 1.3-2.072-.858z","fill":"#E7E5EC"}})])
          )
        }
      }
    